import React from 'react';
import { FadeIn } from './FadeIn';
export function ChapterOverview() {
  const chapters = [{
    num: '01',
    title: 'Bienvenida al Caos',
    desc: 'Validación emocional real — alguien que finalmente entiende lo que estás viviendo'
  }, {
    num: '02',
    title: 'La Ciencia del Sueño Explicada Fácil',
    desc: 'Por qué tu bebé duerme como duerme — y por qué eso cambia todo'
  }, {
    num: '03',
    title: 'Qué Hacer Esta Noche',
    desc: 'Estrategias concretas que puedes aplicar hoy — ambiente, rutina, respuesta al llanto'
  }, {
    num: '04',
    title: 'Errores Frecuentes y Cómo Corregirlos',
    desc: 'Los 6 hábitos que sin saberlo están prolongando los despertares nocturnos'
  }, {
    num: '05',
    title: 'Rutinas Semana a Semana',
    desc: 'Tu plan exacto adaptado a la edad de tu bebé — desde la semana 1 hasta el mes 6'
  }, {
    num: '06',
    title: 'Cuando el Cuerpo de Mamá También Necesita Dormir',
    desc: 'Estrategias de descanso para ti — porque tú también importas en esta historia'
  }, {
    num: '07',
    title: 'Cuando Nada Parece Funcionar',
    desc: 'Diagnóstico honesto, casos complejos y el protocolo para las noches más difíciles'
  }];
  return <section className="bg-white py-24 px-6" data-id="element-49">
      <div className="max-w-5xl mx-auto" data-id="element-50">
        <FadeIn data-id="element-51">
          <div className="text-center mb-16" data-id="element-52">
            <h2 className="text-3xl md:text-4xl font-bold text-azul-noche mb-4" data-id="element-53">
              7 capítulos diseñados para que puedas empezar esta misma noche
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-54">
          <div className="overflow-x-auto" data-id="element-55">
            <table className="w-full min-w-[800px] border-collapse rounded-2xl overflow-hidden shadow-lg border border-gray-100" data-id="element-56">
              <thead data-id="element-57">
                <tr className="bg-azul-noche text-white" data-id="element-58">
                  <th className="py-5 px-6 text-left font-serif text-lg font-medium w-24" data-id="element-59">
                    Capítulo
                  </th>
                  <th className="py-5 px-6 text-left font-serif text-lg font-medium w-1/3" data-id="element-60">
                    Contenido
                  </th>
                  <th className="py-5 px-6 text-left font-serif text-lg font-medium" data-id="element-61">
                    Lo que obtienes
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-62">
                {chapters.map((chapter, index) => <tr key={index} className={`border-b border-gray-100 ${index % 2 === 0 ? 'bg-white' : 'bg-crema/30'}`} data-id="element-63">
                    <td className="py-6 px-6" data-id="element-64">
                      <div className="flex flex-col items-center justify-center bg-lila-suave/20 rounded-lg p-2 w-14 h-14" data-id="element-65">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1B2A4A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mb-1" data-id="element-66">
                          <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" data-id="element-67" />
                        </svg>
                        <span className="font-bold text-azul-noche text-sm" data-id="element-68">
                          {chapter.num}
                        </span>
                      </div>
                    </td>
                    <td className="py-6 px-6 font-bold text-azul-noche text-lg" data-id="element-69">
                      {chapter.title}
                    </td>
                    <td className="py-6 px-6 text-texto" data-id="element-70">{chapter.desc}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </FadeIn>
      </div>
    </section>;
}